import {defineStore} from 'pinia'

// useApplicationStore
export const useApplicationStore = defineStore('Application', {
  // state
  state: () => {
    return {
      title: null,
    }
  },

  // getters
  getters: {
    // ua
    // - 2023.08.04
    // - User agent string in lower case
    ua () {
      return window.navigator.userAgent.toLowerCase()
    },

    // android
    // - 2023.08.04
    // - Test if it's a Android Device
    android () {
      return this.ua
        ? /android/.test(this.ua)
        : false
    },

    // ios
    // - 2023.08.04
    // - Test if it's a iOS device
    ios () {
      return this.ua
        ? /(ipad|iphone|ipod)/ig.test(this.ua)
        : false
    },

    // mobile
    // - 2023.08.04
    // - If it's a iOS or Android, it's a mobile device,
    //   not very accurate at time being, but let's go with this for nows
    mobile () {
      return this.ios || this.android
    },

    // wechat
    // see if inside wechat.app
    wechat () {
      return this.ua
        ? /micromessenger/.test(this.ua) && !/wxwork/.test(this.ua)
        : false
    },

    // wework
    // see if inside wewrok.app
    wework () {
      return this.ua
        ? /micromessenger/.test(this.ua) && /wxwork/.test(this.ua)
        : false
    },

    // douyin
    // see if inside douyin.app
    douyin () {
      return this.ua
        ? /toutiaomicroapp/ig.test(this.ua)
        : false
    },
  },

  // actions
  actions: {
    // updateApplicationTitle
    updateTitle (title) {
      document.title = title
      this.title = title
    },
  },
})
